import { render, staticRenderFns } from "./problem-report-measures.vue?vue&type=template&id=5320190c"
import script from "./problem-report-measures.vue?vue&type=script&lang=js"
export * from "./problem-report-measures.vue?vue&type=script&lang=js"
import style0 from "./problem-report-measures.vue?vue&type=style&index=0&id=5320190c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports